import React from 'react';
import { useForbidden } from '../../hooks/useForbidden';
import { TcsmFeatures } from '../../models/features-model';
import { ForbiddenErrorMessage } from '../forbidden-error-message';

export const withForbidden = (feature: TcsmFeatures) => (WrappedComponent: React.ComponentType<any>) => {
    return (props: React.PropsWithChildren<any>) => {
        const forbiddenError = useForbidden(feature);
        return forbiddenError
            ? <ForbiddenErrorMessage code={forbiddenError.code} />
            : (
                <WrappedComponent {...props}>
                    {props.children}
                </WrappedComponent>
            );
    };
};
